<template>
  <div class="masterdata-full">
    <Loading v-if="$store.state.globalLoading" />
    <div class="masterdata-table">
      <div class="matrix-width">
        <div class="grid-container-matrix">
          <div class="item">* Keterangan : </div>
          <div class="item">1 = Mandatory</div>
          <div class="item">11 = Group 1 (salah satu mandatory)</div>
          <div class="item">13 = Group 3 (salah satu mandatory)</div>
          <div class="item"> </div>
          <div class="item">0 = Tidak Mandatory</div>
          <div class="item">12 = Group 2 (salah satu mandatory)</div>
          <div class="item"> </div>
        </div>
      </div>
      <table class="table-matrix">
        <col>
        <colgroup span="2"></colgroup>
        <colgroup span="2"></colgroup>
        <tr class="text-center">
          <th rowspan="2" scope="colgroup">No</th>
          <th rowspan="2" scope="colgroup">BADAN USAHA</th>
          <th rowspan="2" scope="colgroup">TYPE</th>
          <th rowspan="2" scope="colgroup">DESKRIPSI</th>
          <th :colspan="legalType(0).length" scope="colgroup">DEFAULT</th>
          <th :colspan="legalType(1).length" scope="colgroup">AKTA</th>
          <th :colspan="legalType(2).length" scope="colgroup">KOMERSIAL</th>
          <th :colspan="legalType(3).length" scope="colgroup">PERIZINAN</th>
          <th :colspan="legalType(5, [38, 39]).length" scope="colgroup">PENGURUS</th>
        </tr>
        <tr class="text-center">
          <th v-for="(item, index) in legalType(0)">
            {{ item.desc }}
          </th>
          <th v-for="(item, index) in legalType(1)">
            {{ item.desc }}
          </th>
          <th v-for="(item, index) in legalType(2)">
            {{ item.desc }}
          </th>
          <th v-for="(item, index) in legalType(3)">
            {{ item.desc }}
          </th>
          <th v-for="(item, index) in legalType(5, [38, 39])">
            {{ item.desc }}
          </th>
        </tr>
        <tr v-for="(list, index) in activeBadanUsaha" :key="index">
          <td>
            <span style="display: flex;">
              <div v-if="isEdit" class="editRow" @click="editRow(list)"><span class="fa fa-edit pointer"></span></div>
              &nbsp;{{ index + 1 }}
            </span>
          </td>
          <td style="text-align: left;">{{ list.bidang_usaha_id == 1 ? 'Badan Usaha' : 'Perorangan' }}</td>
          <td style="text-align: left;">{{ list.type_pendaftaran.desc }}</td>
          <td style="text-align: left;">{{ list.desc }}</td>
          <td v-for="(item, index) in legalType(0)">
            {{ checkMatrix(list.id, item.id) }}
          </td>
          <td v-for="(item, index) in legalType(1)">
            {{ checkMatrix(list.id, item.id) }}
          </td>
          <td v-for="(item, index) in legalType(2)">
            {{ checkMatrix(list.id, item.id) }}
          </td>
          <td v-for="(item, index) in legalType(3)">
            {{ checkMatrix(list.id, item.id) }}
          </td>
          <td v-for="(item, index) in legalType(5, [38, 39])">
            {{ checkMatrix(list.id, item.id) }}
          </td>
        </tr>
      </table>
    </div>
    <EditForm v-if="showModalEdit" :editData="editData" @closeModal="closeModal" class="notAll" />
  </div>
</template>

<script>
export default {
  components: {
    EditForm: () => import('@/components/masterdata/matrix/legal-dokumen/editform.vue'),
    Loading: () => import('@/components/V2/GlobalLoading'),
  },

  props: {
    'isEdit': Boolean,
  },
  data() {
    return {
      currentSort: '',
      currentSortDir: '',
      arrow: false,
      showModalEdit: false,
    }
  },

  created() {
    this.$store.dispatch('mdMatrixLegalStore/getAll')
  },

  computed: {
    activeBadanUsahaAll() {
      const badan = this.$store.state.mdMatrixLegalStore.badan_usaha
      let filterBadan = badan.filter((b) => b.type_pendaftaran_id === 1 && b.bidang_usaha_id === 1)
      return filterBadan
    },
    activeBadanUsaha() {
      const badan = this.$store.state.mdMatrixLegalStore.badan_usaha_active
      // let filterBadan = badan.filter((b) => b.type_pendaftaran_id === 1 && b.bidang_usaha_id === 1)
      return badan
    },
    matrix() {
      const matrix = this.$store.state.mdMatrixLegalStore.matrix
      return matrix
    },
    legalDoc() {
      const legal = this.$store.state.mdMatrixLegalStore.legal_doc
      return legal
    },
    activeLegal() {
      const legal = this.$store.state.mdMatrixLegalStore.legal_doc_active
      return legal
    },
    sortedData() {
      return this.data.sort((a, b) => {
        let modifier = 1;
        if (this.currentSortDir === 'desc') modifier = -1;
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
        return 0;
      });
    },
  },

  methods: {
    legalType(type, block = []) {
      const legal = this.activeLegal.filter((l) => l.type === type)

      if (block.length > 0) {
        return legal.filter((l) => !block.includes(l.id))
      }
      return legal
    },
    checkMatrix(m_badan_usaha_id, legal_document_id) {
      const matrix = this.matrix.find((m) => m.m_badan_usaha_id === m_badan_usaha_id && m.legal_document_id === legal_document_id)
      if (matrix) {
        return matrix.is_mandatory
      }
      return 0
    },
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    editRow(data) {
      this.editData = {
        nama: data.desc,
        id: data.id,
      }

      let legalDefault = this.legalType(0).map((item) => {
        return {
          id: item.id,
          value: this.checkMatrix(data.id, item.id),
          name: item.desc,
          type: item.type,
        }
      })

      let legalAkta = this.legalType(1).map((item) => {
        return {
          id: item.id,
          value: this.checkMatrix(data.id, item.id),
          name: item.desc,
          type: item.type,
        }
      })

      let legalKomersial = this.legalType(2).map((item) => {
        return {
          id: item.id,
          value: this.checkMatrix(data.id, item.id),
          name: item.desc,
          type: item.type,
        }
      })

      let legalPerizinan = this.legalType(3).map((item) => {
        return {
          id: item.id,
          value: this.checkMatrix(data.id, item.id),
          name: item.desc,
          type: item.type,
        }
      })

      let legalPengurus = this.legalType(5, [38, 39]).map((item) => {
        return {
          id: item.id,
          value: this.checkMatrix(data.id, item.id),
          name: item.desc,
          type: item.type,
        }
      })

      let legalCombine = [
        ...legalDefault,
        ...legalAkta,
        ...legalKomersial,
        ...legalPerizinan,
        ...legalPengurus
      ]

      this.editData.legal_dokumen = legalCombine

      this.showModalEdit = true;
    },
    closeModal() {
      this.showModalEdit = false;
    },
  },
}
</script>